(function () {
  // Mobile navigation
  var menu = document.getElementById('menuBtn');
  var links = document.getElementById('navigation');
  if (menu && links) {
    var close = function () {
      links.classList.remove('open');
      menu.setAttribute('aria-expanded', 'false');
      menu.textContent = '☰';
    };
    menu.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      menu.setAttribute('aria-expanded', open);
      menu.textContent = open ? '✕' : '☰';
    });
    links.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Pre-select the project type when a "quote" link is clicked
  function selectService(value) {
    var select = document.querySelector('[data-rfq-service]');
    if (!select || !value) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) { select.value = value; return true; }
    }
    return false;
  }
  document.querySelectorAll('[data-service]').forEach(function (a) {
    a.addEventListener('click', function () { selectService(a.dataset.service); });
  });

  // Support links like /?service=Product%20Name#quote (used on product pages)
  var params = new URLSearchParams(window.location.search);
  var fromUrl = params.get('service');
  if (fromUrl && !selectService(fromUrl)) {
    selectService('Other Custom Project');
    var details = document.querySelector('[data-rfq-details]');
    if (details && !details.value) details.value = 'Product of interest: ' + fromUrl + '\n\n';
  }

  // Product page: keep variant id in sync with the option selector
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-product-price]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      priceEl.textContent = opt.dataset.price || priceEl.textContent;
      var btn = document.querySelector('[data-add-to-cart]');
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
      }
    });
  }
})();
